export const styles = {
    listWrapper: {
        height: "100%"
    },
    schemaListContainer: {
        backgroundColor: "additional.white",
        height: `calc(100% - 70px)`,
        overflowY: "auto"
    },
    schemaSelected: {
        backgroundColor: ({ palette }) => `${palette.greyscale[100]} !important`
    },
    radioListItem: {
        marginBottom: `0 !important`
    },
    schemaItem: {
        fontWeight: 500,
        minWidth: 0
    },
    label: {
        width: "100%",
        overflow: "hidden"
    },
    schemaListItem: {
        color: "greyscale.700"
    },
    schemaListItemSelected: {
        color: "primary.700"
    },
    listItemCaption: {
        color: "greyscale.600"
    },
    selectedListItemCaption: {
        color: "greyscale.700"
    }
};
